// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_org_fsd_template.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { StcsOrgFsdStructFstmt } from "./stcs_org_fsd_struct.entity";

export const protobufPackage = "stcs_cmw";

export interface StcsOrgFsdTemplate {
  id: string;
  version: string;
  meta: StcsOrgFsdTemplateMeta | undefined;
  pnl: StcsOrgFsdStructFstmt | undefined;
  bs: StcsOrgFsdStructFstmt | undefined;
  cf: StcsOrgFsdStructFstmt | undefined;
}

export interface StcsOrgFsdTemplateMeta {
  fpna_industry: number;
  display_name: string;
  version_name: string;
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
}

export interface OrgGetFsdTemplateList {
  list: StcsOrgFsdTemplateMeta[];
}

function createBaseStcsOrgFsdTemplate(): StcsOrgFsdTemplate {
  return { id: "", version: "", meta: undefined, pnl: undefined, bs: undefined, cf: undefined };
}

export const StcsOrgFsdTemplate: MessageFns<StcsOrgFsdTemplate> = {
  encode(message: StcsOrgFsdTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsOrgFsdTemplateMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    if (message.pnl !== undefined) {
      StcsOrgFsdStructFstmt.encode(message.pnl, writer.uint32(34).fork()).join();
    }
    if (message.bs !== undefined) {
      StcsOrgFsdStructFstmt.encode(message.bs, writer.uint32(42).fork()).join();
    }
    if (message.cf !== undefined) {
      StcsOrgFsdStructFstmt.encode(message.cf, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsOrgFsdTemplateMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pnl = StcsOrgFsdStructFstmt.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.bs = StcsOrgFsdStructFstmt.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cf = StcsOrgFsdStructFstmt.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdTemplate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsOrgFsdTemplateMeta.fromJSON(object.meta) : undefined,
      pnl: isSet(object.pnl) ? StcsOrgFsdStructFstmt.fromJSON(object.pnl) : undefined,
      bs: isSet(object.bs) ? StcsOrgFsdStructFstmt.fromJSON(object.bs) : undefined,
      cf: isSet(object.cf) ? StcsOrgFsdStructFstmt.fromJSON(object.cf) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsOrgFsdTemplateMeta.toJSON(message.meta);
    }
    if (message.pnl !== undefined) {
      obj.pnl = StcsOrgFsdStructFstmt.toJSON(message.pnl);
    }
    if (message.bs !== undefined) {
      obj.bs = StcsOrgFsdStructFstmt.toJSON(message.bs);
    }
    if (message.cf !== undefined) {
      obj.cf = StcsOrgFsdStructFstmt.toJSON(message.cf);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdTemplate>, I>>(base?: I): StcsOrgFsdTemplate {
    return StcsOrgFsdTemplate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdTemplate>, I>>(object: I): StcsOrgFsdTemplate {
    const message = createBaseStcsOrgFsdTemplate();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsOrgFsdTemplateMeta.fromPartial(object.meta)
      : undefined;
    message.pnl = (object.pnl !== undefined && object.pnl !== null)
      ? StcsOrgFsdStructFstmt.fromPartial(object.pnl)
      : undefined;
    message.bs = (object.bs !== undefined && object.bs !== null)
      ? StcsOrgFsdStructFstmt.fromPartial(object.bs)
      : undefined;
    message.cf = (object.cf !== undefined && object.cf !== null)
      ? StcsOrgFsdStructFstmt.fromPartial(object.cf)
      : undefined;
    return message;
  },
};

function createBaseStcsOrgFsdTemplateMeta(): StcsOrgFsdTemplateMeta {
  return { fpna_industry: 0, display_name: "", version_name: "", obj_created_iso_utc: "", obj_updated_iso_utc: "" };
}

export const StcsOrgFsdTemplateMeta: MessageFns<StcsOrgFsdTemplateMeta> = {
  encode(message: StcsOrgFsdTemplateMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fpna_industry !== 0) {
      writer.uint32(8).uint32(message.fpna_industry);
    }
    if (message.display_name !== "") {
      writer.uint32(18).string(message.display_name);
    }
    if (message.version_name !== "") {
      writer.uint32(26).string(message.version_name);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(34).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(42).string(message.obj_updated_iso_utc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdTemplateMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdTemplateMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.version_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdTemplateMeta {
    return {
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : 0,
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      version_name: isSet(object.version_name) ? globalThis.String(object.version_name) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
    };
  },

  toJSON(message: StcsOrgFsdTemplateMeta): unknown {
    const obj: any = {};
    if (message.fpna_industry !== 0) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.version_name !== "") {
      obj.version_name = message.version_name;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdTemplateMeta>, I>>(base?: I): StcsOrgFsdTemplateMeta {
    return StcsOrgFsdTemplateMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdTemplateMeta>, I>>(object: I): StcsOrgFsdTemplateMeta {
    const message = createBaseStcsOrgFsdTemplateMeta();
    message.fpna_industry = object.fpna_industry ?? 0;
    message.display_name = object.display_name ?? "";
    message.version_name = object.version_name ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    return message;
  },
};

function createBaseOrgGetFsdTemplateList(): OrgGetFsdTemplateList {
  return { list: [] };
}

export const OrgGetFsdTemplateList: MessageFns<OrgGetFsdTemplateList> = {
  encode(message: OrgGetFsdTemplateList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.list) {
      StcsOrgFsdTemplateMeta.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgGetFsdTemplateList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgGetFsdTemplateList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.list.push(StcsOrgFsdTemplateMeta.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgGetFsdTemplateList {
    return {
      list: globalThis.Array.isArray(object?.list)
        ? object.list.map((e: any) => StcsOrgFsdTemplateMeta.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OrgGetFsdTemplateList): unknown {
    const obj: any = {};
    if (message.list?.length) {
      obj.list = message.list.map((e) => StcsOrgFsdTemplateMeta.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgGetFsdTemplateList>, I>>(base?: I): OrgGetFsdTemplateList {
    return OrgGetFsdTemplateList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgGetFsdTemplateList>, I>>(object: I): OrgGetFsdTemplateList {
    const message = createBaseOrgGetFsdTemplateList();
    message.list = object.list?.map((e) => StcsOrgFsdTemplateMeta.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
